import React from "react";
import { X } from "./icons";

const Dialog = ({ children, open, onOpenChange }: any) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-zinc-900 rounded-lg shadow-lg max-w-md w-full relative">
        {children}
        <div className="absolute top-0 right-0 p-4">
          <button onClick={() => onOpenChange(false)} className="text-zinc-400 hover:text-white focus:outline-none">
            <X size={24} />
          </button>
        </div>
      </div>
    </div>
  );
};

const DialogContent = ({ children, className }: any) => (
  <div className={`p-6 ${className}`}>{children}</div>
);

const DialogHeader = ({ children }: any) => <div className="mb-4">{children}</div>;
const DialogTitle = ({ children }: any) => <h2 className="text-xl font-bold">{children}</h2>;
const DialogDescription = ({ children }: any) => <p className="text-zinc-400 text-sm">{children}</p>;
const DialogFooter = ({ children }: any) => <div className="mt-6 flex justify-end gap-2">{children}</div>;

const Button = ({ children, className, onClick, type }: any) => (
  <button
    className={`px-4 py-2 rounded font-medium focus:outline-none ${className}`}
    onClick={onClick}
    type={type}
  >
    {children}
  </button>
);

interface ConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  destructive?: boolean;
}

export function ConfirmationDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  destructive = false
}: ConfirmationDialogProps) {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] bg-zinc-900 text-white border-zinc-700">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            className="bg-zinc-700 hover:bg-zinc-600 text-white"
          >
            {cancelText}
          </Button>
          <Button
            type="button"
            onClick={handleConfirm}
            className={destructive ? "bg-red-600 hover:bg-red-700 text-white" : "bg-emerald-600 hover:bg-emerald-700 text-white"}
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}